// extracted by css-extract-rspack-plugin
export default {"closeButtonContainer":"closeButtonContainer-mHW6BO","reasonContainer":"reasonContainer-gJu0sL","reasonLabel":"reasonLabel-Q8fhpo text-sm-semibold"};